export default __webpack_public_path__ + "static/media/bite-eth-closed-logo.639df6ee.svg";